import React from 'react';
import { inject, observer } from "mobx-react";
import { Button, Space, Badge } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, ThunderboltOutlined } from '@ant-design/icons';

@inject('currentItem')
@observer
export class VariantsBulkEditor extends React.Component {
    bulkAvailableInCatalog = (available) =>
        this.props.currentItem.variants.forEach(variant => variant.setAvailableInCatalog(available));

    createAllVariants = () => {
        const { currentItem } = this.props;

        const nonEmptyTypes = currentItem.variationsTypes.filter(vt => vt.variations.length > 0);
        if (nonEmptyTypes.length === 0) return;

        const variationArrays = nonEmptyTypes.map(vt => vt.variations.map(v => v.id));
        const imageIdByVariationId = new Map();
        nonEmptyTypes.forEach(vt =>
            vt.variations.forEach(v => imageIdByVariationId.set(v.id, v.imageId))
        );

        const combinations = variationArrays.reduce(
            (acc, arr) => acc.flatMap(combo => arr.map(id => [...combo, id])),
            [[]]
        );

        const existingKeys = new Set(
            currentItem.variants.map(v => [...v.variationsIds].sort().join(','))
        );

        for (const combo of combinations) {
            if (!existingKeys.has([...combo].sort().join(','))) {
                const variant = currentItem.constructVariant();
                combo.forEach(id => variant.variationsIds.push(id));
                const inheritedImageId = combo
                    .map(id => imageIdByVariationId.get(id))
                    .find(imageId => !!imageId);
                if (inheritedImageId) variant.setImageId(inheritedImageId);
            }
        }
    };

    render() {
        const { currentItem } = this.props;

        const variationArrays = currentItem.variationsTypes
            .filter(vt => vt.variations.length > 0)
            .map(vt => vt.variations.length);
        const total = variationArrays.reduce((acc, n) => acc * n, variationArrays.length > 0 ? 1 : 0);
        const missingCount = Math.max(0, total - currentItem.variants.length);
        const hasAllVariants = missingCount === 0;

        return (
            <Space wrap>
                <Button
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => this.bulkAvailableInCatalog(true)}
                >
                    Show all in catalog
                </Button>
                <Button
                    size="small"
                    icon={<EyeInvisibleOutlined />}
                    danger
                    onClick={() => this.bulkAvailableInCatalog(false)}
                >
                    Hide all from catalog
                </Button>
                <Badge count={hasAllVariants ? 0 : missingCount} size="small">
                    <Button
                        size="small"
                        icon={<ThunderboltOutlined />}
                        disabled={total === 0 || hasAllVariants}
                        onClick={this.createAllVariants}
                    >
                        Create all variants
                    </Button>
                </Badge>
            </Space>
        );
    }
}
